/**
 * Templates Feature
 *
 * Feature module for template management using the V2 denormalized template system.
 * Templates are self-contained with inline section content and explicit permissions.
 *
 * Features:
 * - Template list with backend-sorted ordering
 * - Template editor with section management
 * - Template library browser
 * - Fork and add functionality
 */

import { autoRegisterFeature } from '@store/features/factory';

import { templatesFeature } from './store/feature';

// Auto-register the feature with Redux store
autoRegisterFeature(templatesFeature);

// Main page component
export { TemplatesPage } from './TemplatesPage';

// Store exports
export * from './store';

// Hooks
export { useTemplateEditor, useTemplateLibrary, useTemplates } from './hooks';

// Components
export * from './components';

// Types
export * from './types';

// Constants
export * from './constants';

// Utilities (template info extraction, format detection)
export * from './utils';
